<div class="challenge-cover-field full">
  <h3 class="full">Cover / hero</h3>
  <div class="preview full" *ngIf="imageSrc as src">
    <img [src]="src" alt="Challenge cover" (error)="onImageError($event)" />
  </div>
  <mat-form-field appearance="outline" class="full">
    <mat-label>Cover image URL or key</mat-label>
    <input matInput formControlName="coverImageUrl" placeholder="Upload, generate, or paste a URL" />
  </mat-form-field>
  <div class="actions full">
    <input #coverFileInput type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden (change)="onFileSelected($event)" />
    <button mat-stroked-button type="button" (click)="coverFileInput.click()" [disabled]="uploading || !challengeId">
      Upload cover
    </button>
    <button
      mat-stroked-button
      type="button"
      (click)="generateCover()"
      [disabled]="generating || !challengeId || !canGenerate"
    >
      Generate from summary
    </button>
  </div>
  <p class="meta full" *ngIf="!canGenerate">Add a title and summary to enable AI cover generation.</p>
  <mat-progress-bar *ngIf="uploading || generating" mode="indeterminate"></mat-progress-bar>
  <p class="error full" *ngIf="actionError">{{ actionError }}</p>
</div>